/**
 * 浏览器平台
 */
import Browser from './types/browser';

// 引入 qs，依赖的 object-inspect 有问题，暂时不引入
const getQueryString = (name: string) => {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
};

// url参数解析
const urlSource = getQueryString('source');

// 缓存source标识
const SOURCE = 'customer-source';
const sourceIs = (source: string) => {
  return window.sessionStorage.getItem(SOURCE) === source || urlSource === source;
};

const ua = navigator.userAgent.toLowerCase();
const browser: Browser = {
  mobile: ua.includes('mobile'), // 是否为移动终端
  win: ua.includes('windows'), // windows平台
  mac: ua.includes('mac'), // mac平台
  ios: /ip(hone|ad|od)/i.test(ua), // ios设备
  android: /android/i.test(ua), // android设备
  harmony: /harmony/i.test(ua), // 鸿蒙设备
  weixin: ua.includes('micromessenger'), // 微信/企业微信
  wxwork: ua.includes('wxwork'), // 企业微信
  dingding: ua.includes('dingtalk'), // 钉钉
  feishu: ua.includes('lark'), // 飞书
  ovopark: ua.includes('ovopark'), // 万店掌App
  cmiot: ua.includes('hemustar'), // 中移物联网App
  weaver: ua.includes('e-mobile'), // 泛微App
  yadea: sourceIs('yadea'), // 雅迪App
  zhongtian: sourceIs('zhongtian'), // 中田客户，移动端使用泛微App
  cdyysj: sourceIs('cdyysj'), // 成都孕婴世界App
  isIframe: window !== window.top, // 是否在iframe页面
  miniProgram: ua.includes('miniprogram'), // 是否小程序内
};
if (!browser.cmiot) {
  // 兼容 中移物联网App 部分机型 userAgent 未加 hemustar
  browser.cmiot = /(?=.*region=.+?;)(?=.*uid=.+?;)(?=.*userPhone=.+?;)/.test(document.cookie + ';');
}
if (urlSource) {
  // sessionStorage 缓存source标识
  window.sessionStorage.setItem(SOURCE, urlSource);
}

// 浏览器内核
let matched: RegExpMatchArray | null;
if ((matched = ua.match(/edge\/([\d.]+)/))) {
  browser.edge = true;
} else if ((matched = ua.match(/rv:([\d.]+)\) like gecko/))) {
  browser.ie = true;
} else if ((matched = ua.match(/msie ([\d.]+)/))) {
  browser.ie = true;
} else if ((matched = ua.match(/firefox\/([\d.]+)/))) {
  browser.firefox = true;
} else if ((matched = ua.match(/tbs\/([\d.]+)/))) {
  browser.x5 = true;
} else if ((matched = ua.match(/chrome\/([\d.]+)/))) {
  browser.chrome = true;
} else if ((matched = ua.match(/opera.([\d.]+)/))) {
  browser.opera = true;
} else if ((matched = ua.match(/version\/([\d.]+).*safari/))) {
  browser.safari = true;
}
// 浏览器版本
if (matched) {
  browser.version = parseInt(matched[1]);
}
// 移动端 系统版本
if (browser.android) {
  matched = ua.match(/android ([\d.]+)/);
  browser.androidVersion = parseInt(matched![1]);
} else if (browser.ios) {
  matched = ua.match(/os (\d+)_/);
  browser.iosVersion = parseInt(matched![1]);
} else if (browser.harmony) {
  matched = ua.match(/harmony ([\d.]+)/);
  browser.harmonyVersion = parseInt(matched![1]);
}
if (!browser.mobile && (browser.android || browser.ios || browser.harmony)) {
  // 3大系统（平板）也归为移动端
  browser.mobile = true;
}

browser.isThirdApp = browser.mobile && (browser.cmiot || browser.yadea || browser.cdyysj);

export default browser;
